// src/belediye/components/notifications/PushBaslatici.js
//
// FAZ-84 — TELEFON BİLDİRİMİ BAŞLATICISI. Hiçbir şey ÇİZMEZ (null döner).
//
// Personel panelinde, kullanıcı giriş yaptıktan SONRA bir kez monte edilir ve
// üç işi üstlenir:
//
//   1. MANİFEST DEĞİŞİMİ — sayfa /yonetim altındayken "Ana Ekrana Ekle"
//      manifest-personel.json'u okusun. Böylece personelin kurduğu uygulama
//      ikonu /yonetim'e açılır; bugünkü davranışta VATANDAŞ sayfasına düşüyordu.
//      (Hem iOS hem Android, ekleme ANINDA o sayfadaki manifesti okur.)
//
//   2. NÖBETÇİ EŞİTLEMESİ — kayıt + güncelleme yoklaması + varsa aboneliğin
//      sunucuyla tazelenmesi. İZİN İSTEMEZ; izin yalnız kullanıcı rehberdeki
//      düğmeye bastığında istenir (iOS izin istemini yalnız dokunuşla gösterir).
//
//   3. NÖBETÇİDEN GELEN MESAJLAR — bildirime dokunulduğunda açık sekme
//      odaklanır ve yönlendirme isteği buraya düşer; React router ile gidilir
//      (yeni sekme AÇILMAZ).
//
// AYRI BİLEŞEN OLMASININ SEBEBİ: BelediyeApp zaten çok büyük ve FAZ-80'de
// gövde-içi bileşen tanımı sayfayı söktürmüştü. Bu iş kendi dosyasında,
// kendi yaşam döngüsünde durur.
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { selectUnreadCountAll } from "../../redux/slices/belediyeNotificationsSlice";
import { senkronEt, destekVar, durumOku } from "../../services/pushIstemci";
import { asamaBelirle, gosterilsinMi } from "../../services/kurulumRehberiZaman";
import KurulumRehberi from "./KurulumRehberi";

const PERSONEL_MANIFEST = "/manifest-personel.json";

// ── REHBER NE ZAMAN AÇILIR ──────────────────────────────────────────────────
//
// GİRİŞTE DEĞİL. Kişi panele bir iş yapmak için gelir; kapıda karşısına çıkan
// her şey engeldir ve refleks olarak kapatılır. Bunun yerine:
//
//   • Okunmamış bildirimi VARSA 4 saniye sonra. O an telefon bildiriminin ne
//     işe yaradığı kendiliğinden anlaşılır ("bu satırı telefonunda da gör") —
//     aynı cümle girişte ikna etmez, burada eder.
//   • Yoksa 45 saniye sonra. Kişi o sırada işine dalmıştır; rehber araya
//     girmek yerine bekler.
const GECIKME_BILDIRIMLI_MS = 4000;
const GECIKME_SESSIZ_MS = 45000;

function manifestiPersonelYap() {
  try {
    const bag = document.querySelector('link[rel="manifest"]');
    if (!bag) return;
    // href mutlak URL'e çözülür; sonuna bakmak yeterli.
    if (String(bag.getAttribute("href") || "").endsWith("manifest-personel.json")) return;
    bag.setAttribute("href", PERSONEL_MANIFEST);
  } catch (_) {}
}

export default function PushBaslatici() {
  const navigate = useNavigate();
  const okunmamis = useSelector(selectUnreadCountAll);
  const userId = useSelector((s) => (s && s.belediyeAuth && s.belediyeAuth.user
    ? s.belediyeAuth.user.id
    : null));
  const [rehberAsama, setRehberAsama] = useState(null);

  useEffect(() => {
    manifestiPersonelYap();
  }, []);

  // ── İKON ROZETİ (uygulama simgesinin üstündeki sayı) ─────────────────────
  //
  // Nöbetçi, push GELDİĞİNDE rozeti yazıyor (sw.js). Ama rozeti DÜŞÜREN bir
  // şey olmazsa sayı okuduktan sonra da ekranda kalır ve bir daha asla
  // sıfırlanmaz — "9 bildirimin var" diyen ama hepsi okunmuş bir ikon,
  // rozeti tümden anlamsızlaştırır. Bu yüzden düşürme İŞİ SAYFADA:
  // okunmamış sayısı her değiştiğinde rozet güncellenir, sıfırlanınca silinir.
  //
  // Sayı yine BACKEND'in saydığıdır (FAZ-51: sayaç otoritesi sunucuda) —
  // burada yalnız zaten hesaplanmış değer işletim sistemine iletiliyor.
  // Desteklemeyen ortamda (masaüstü tarayıcı sekmesi, eski iOS) sessizce atlanır.
  useEffect(() => {
    try {
      if (typeof navigator === "undefined" || !navigator.setAppBadge) return;
      const n = Number(okunmamis) || 0;
      if (n > 0) navigator.setAppBadge(n).catch(() => {});
      else if (navigator.clearAppBadge) navigator.clearAppBadge().catch(() => {});
    } catch (_) {}
  }, [okunmamis]);

  useEffect(() => {
    let iptal = false;

    // Açılış eşitlemesi. Hata yutulur: telefon bildirimi altyapısı, uygulamanın
    // açılmasını HİÇBİR koşulda engellememelidir.
    //
    // FAZ-100 — BU ÇAĞRI ARTIK `destekVar()` KAPISININ ÖNÜNDE.
    // Eskiden destek yoksa efekt hiç çalışmıyordu. Ama iPhone'da uygulama ana
    // ekrana eklenene kadar destek ZATEN yoktur; yani "hiç kurmamış iPhone
    // kullanıcısı" hakkında tek satır bile veri toplanamıyordu — oysa yönetici
    // raporunun asıl aradığı kişi odur. senkronEt() kendi içinde destek
    // kontrolünü yapıyor, önce cihaz hâlini bildiriyor.
    senkronEt().catch(() => {});

    if (!destekVar()) return undefined;

    const dinle = (event) => {
      const veri = (event && event.data) || {};
      if (iptal) return;
      if (veri.tip === "bildirim-git" && typeof veri.url === "string") {
        // Yalnız kendi sitemizde kalan göreli yollar (açık yönlendirme önlemi).
        if (veri.url.startsWith("/") && !veri.url.startsWith("//")) {
          navigate(veri.url);
        }
      }
    };

    try {
      navigator.serviceWorker.addEventListener("message", dinle);
    } catch (_) {}

    return () => {
      iptal = true;
      try {
        navigator.serviceWorker.removeEventListener("message", dinle);
      } catch (_) {}
    };
  }, [navigate]);

  // ── KURULUM REHBERİ TETİKLEYİCİSİ ────────────────────────────────────────
  //
  // Ölçüp karar verir, tahmin etmez: sunucuda özellik açık mı, kişi hangi
  // aşamada, bu cihazda kaç kez soruldu. Üçünden biri "hayır" derse hiç
  // çizilmez. Zamanlayıcı temizlenir — bileşen sökülürken açılan bir pencere,
  // sökülmüş bir ağaca çizmeye çalışmak olurdu.
  useEffect(() => {
    let iptal = false;
    let zamanlayici = null;

    const bak = async () => {
      let durum;
      try {
        durum = await durumOku();
      } catch (_) {
        return;
      }
      if (iptal || !durum || !durum.sunucuAktif) return;

      const asama = asamaBelirle(durum);
      if (asama === "tamam") return;
      if (!gosterilsinMi({ userId, asama })) return;
      if (!iptal) setRehberAsama(asama);
    };

    zamanlayici = window.setTimeout(
      bak,
      Number(okunmamis) > 0 ? GECIKME_BILDIRIMLI_MS : GECIKME_SESSIZ_MS
    );

    return () => {
      iptal = true;
      if (zamanlayici) window.clearTimeout(zamanlayici);
    };
    // Yalnız İLK yüklemede kurulur: okunmamış sayısı her değiştiğinde
    // zamanlayıcıyı yeniden kurmak, rehberin hiç açılmamasına yol açardı
    // (sayaç sık değişir, geri sayım hep baştan başlardı).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!rehberAsama) return null;
  return (
    <KurulumRehberi
      userId={userId}
      asama={rehberAsama}
      onKapat={() => setRehberAsama(null)}
    />
  );
}
